<template>
    <div class="user-billing">
        <plan-card-boxes
            v-if="user.pro"
            key="plan-card-boxes"
        />
        <shows-list />
        <invoices
            v-if="
                currentSubscription &&
                'none' !== currentSubscription.stripe_id
            "
        />
        <transition-group
            name="fade"
        >
            <div
                v-if="UIState.isUpdateModalVisible"
                key="updateModal"
                class="modal"
            >
                <update-card-modal />
            </div>
            <resume-subscription-modal
                v-if="UIState.isResumeSubscriptionModalVisible"
                key="resume-subscription"
                :subscription-id="currentSubscription.id"
            />
        </transition-group>
    </div>
</template>

<script>
import PlanCardBoxes from '@/components/Dashboard/Settings/Billing/PlanCardBoxes';
import Invoices from '@/components/Dashboard/Settings/Billing/Invoices';
import ShowsList from '@/components/Dashboard/Settings/Billing/ShowsList';
import UpdateCardModal from '@/components/Dashboard/Settings/Billing/UpdateCardModal';
import ResumeSubscriptionModal from '@/components/Dashboard/Settings/Billing/ResumeSubscriptionModal';

import { mapState } from 'vuex';

export default {
    components: {
        PlanCardBoxes,
        Invoices,
        ShowsList,
        UpdateCardModal,
        ResumeSubscriptionModal,
    },

    computed: {
        ...mapState([
            'UIState',
            'user',
            'currentSubscription',
        ]),
    },
};
</script>
